<template>
  <div uk-alert class="alert" :class="containerCss">
    <div class="alert__icon" v-if="icon">
      <icon :name="icon" />
    </div>
    <div class="alert__message">
      <slot>{{message}}</slot>
    </div>
  </div>
</template>

<script>
import DynamicProps from '@/mixins/DynamicProps';

export default {
  name: 'alert-box',
  mixins: [DynamicProps],
  props: {
    message: String,
    type: {
      type: String,
      default: 'primary',
    },
    icon: String,
  },
  computed: {
    containerCss() {
      return `uk-alert-${this.type}`;
    },
  },
};
</script>

<style scoped lang="scss">
.alert__icon {
  position: absolute;
  top: 14px;
}

.alert__icon + .alert__message {
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// AlertBox.vue?14171a39